module.exports = __webpack_public_path__ + "img/home.bb37c588.svg";